"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = exports.__parser_pool = exports.__makeSemantics = exports.ohmGrammar = exports.grammar = void 0;
//@ts-check
var _globals_1 = require("./_globals");
var ohm = require("ohm-js");
exports.grammar = String.raw(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\nArrayGrammar {\n  Instruction\n  = Variable \"[\" Slice \"]\" AssignSymbol ArithmeticLogicExp -- sliceAssignment\n  | ArithmeticLogicExp                       -- expression\n  \n  Variable\n   = \"#\" digit+ \"#\"\n  \n  AssignSymbol\n  =\"=\"|\"+=\"|\"-=\"|\"*=\"|\"/=\"|\"%=\"|\"&=\"|\"|=\"|\"^=\"|\"@=\"|\"**=\"|\"<<=\"|\">>=\"|\"//=\"|\"or=\"|\"and=\"|\"xor=\"|\"max=\"|\"min=\"\n  \n  /* Declaration in precedence order (weakest first) */\n  ArithmeticLogicExp = Precedence11\n\n  /* https://docs.python.org/3/reference/expressions.html */\n  Operator11 = \"<\" | \"<=\" | \">\" | \">=\" | \"!=\" | \"==\"\n  Operator10 = \"|\"\n  Operator09 = \"^\"\n  Operator08 = \"&\"\n  Operator07 = \"<<\" | \">>\"\n  Operator06 = \"+\" | \"-\"\n  Operator05 = \"*\" | \"@\" | \"/\" | \"//\" | \"%\"\n  Operator04 = \"~\" /* Unary */\n  Operator03 = \"+\" | \"-\" /* Unary. Special treatment to prevent \"-1.3\" to be \"-(array of 1.3)\" */\n  Operator02 = \"**\"\n  /* Operator01 = \"x[index]\" | \"x[index:index]\" | \"x(arguments...)\" | \"x.attribute\" */\n  /* Operator00 = \"(expressions...)\" */\n\n  Precedence11 = Precedence11 Operator11 Precedence10 | \"\" \"\" Precedence10\n  Precedence10 = Precedence10 Operator10 Precedence09 | \"\" \"\" Precedence09\n  Precedence09 = Precedence09 Operator09 Precedence08 | \"\" \"\" Precedence08\n  Precedence08 = Precedence08 Operator08 Precedence07 | \"\" \"\" Precedence07\n  Precedence07 = Precedence07 Operator07 Precedence06 | \"\" \"\" Precedence06\n  Precedence06 = Precedence06 Operator06 Precedence05 | \"\" \"\" Precedence05\n  Precedence05 = Precedence05 Operator05 Precedence04 | \"\" \"\" Precedence04\n  Precedence04 = \"\"           Operator04 Precedence03 | \"\" \"\" Precedence03 /* Unary */\n  Precedence03 = \"\"           Operator03 Precedence02 | \"\" \"\" Precedence02 /* Special */\n  Precedence02 = Precedence02 Operator02 Precedence03 | \"\" \"\" Precedence01\n  Precedence01 = Arr\n  \n  Parenthesis = \"(\" ArithmeticLogicExp \")\"\n  Arr\n    = Arr \".\" Name CallArgs     -- method\n    | Arr \".\" Name              -- attribute\n    | Arr \"[\" Slice \"]\"         -- slice\n    | Parenthesis\n    | Name (\".\" Name)* CallArgs -- call\n    | number\n    | Variable\n\n  Name  (an identifier)\n    = (letter|\"_\") (letter|\"_\"|digit)*\n\n  number  (a number)\n    = (\"+\"|\"-\")? digit* \".\" digit+ \"E\" (\"+\"|\"-\")? \"digit+\"\n    | (\"+\"|\"-\")? digit* \".\" digit+ \"e\" (\"+\"|\"-\")? \"digit+\"\n    | (\"+\"|\"-\")? digit* \".\" digit+  \"\"  \"\"        \"\"\n    | (\"+\"|\"-\")? digit+ \"\"  \"\"      \"\"  \"\"        \"\"\n  \n  int (an integer) = \"\"  digit+ | \"-\" digit+ | \"+\" digit+\n\n  CallArgs // Using empty strings instead of separate rules\n   = \"(\" Args \",\"  KwArgs \",\"? \")\"\n   | \"(\" Args \",\"? \"\"      \"\"  \")\"\n   | \"(\" \"\"   \",\"? KwArgs \",\"? \")\"\n   | \"(\" \"\"    \"\"  \"\"      \"\"  \")\"\n   \n  Args = NonemptyListOf<ArgValue, \",\">\n  KwArgs = NonemptyListOf<KwArg, \",\">\n  KwArg = Name \"=\" ArgValue\n\n  ArgValue = Constant | JsArray | ArithmeticLogicExp | String\n  Constant = \"True\" | \"False\" | \"None\" | \"np.nan\" | \"np.inf\"\n  JsArray\n    = \"[\" ListOf<ArgValue, \",\"> \",\"? \"]\"\n    | \"(\" ListOf<ArgValue, \",\"> \",\"? \")\"\n\n  String = \"'\" any* \"'\" | \"\"\" any* \"\"\"\n   \n  Slice = NonemptyListOf<SliceTerm, \",\">\n  SliceTerm\n    = SliceRange\n    | (\":\" | \"...\" | \"None\") -- constant\n    | (\"True\" | \"False\") -- boolean_constant\n    | JsArray\n    | ArithmeticLogicExp\n  \n  SliceRange\n    = int \":\" int \":\" int\n    | int \":\" int \"\"  \"\"\n    | int \":\" \"\"  \":\" int\n    | int \":\" \"\"  \"\"  \"\"\n    | \"\"  \":\" int \":\" int\n    | \"\"  \":\" int \"\"  \"\"\n    | \"\"  \":\" \"\"  \":\" int\n    | \"\"  \":\" \"\"  \"\"  \"\"\n}\n"], ["\nArrayGrammar {\n  Instruction\n  = Variable \"[\" Slice \"]\" AssignSymbol ArithmeticLogicExp -- sliceAssignment\n  | ArithmeticLogicExp                       -- expression\n  \n  Variable\n   = \"#\" digit+ \"#\"\n  \n  AssignSymbol\n  =\"=\"|\"+=\"|\"-=\"|\"*=\"|\"/=\"|\"%=\"|\"&=\"|\"|=\"|\"^=\"|\"@=\"|\"**=\"|\"<<=\"|\">>=\"|\"//=\"|\"or=\"|\"and=\"|\"xor=\"|\"max=\"|\"min=\"\n  \n  /* Declaration in precedence order (weakest first) */\n  ArithmeticLogicExp = Precedence11\n\n  /* https://docs.python.org/3/reference/expressions.html */\n  Operator11 = \"<\" | \"<=\" | \">\" | \">=\" | \"!=\" | \"==\"\n  Operator10 = \"|\"\n  Operator09 = \"^\"\n  Operator08 = \"&\"\n  Operator07 = \"<<\" | \">>\"\n  Operator06 = \"+\" | \"-\"\n  Operator05 = \"*\" | \"@\" | \"/\" | \"//\" | \"%\"\n  Operator04 = \"~\" /* Unary */\n  Operator03 = \"+\" | \"-\" /* Unary. Special treatment to prevent \"-1.3\" to be \"-(array of 1.3)\" */\n  Operator02 = \"**\"\n  /* Operator01 = \"x[index]\" | \"x[index:index]\" | \"x(arguments...)\" | \"x.attribute\" */\n  /* Operator00 = \"(expressions...)\" */\n\n  Precedence11 = Precedence11 Operator11 Precedence10 | \"\" \"\" Precedence10\n  Precedence10 = Precedence10 Operator10 Precedence09 | \"\" \"\" Precedence09\n  Precedence09 = Precedence09 Operator09 Precedence08 | \"\" \"\" Precedence08\n  Precedence08 = Precedence08 Operator08 Precedence07 | \"\" \"\" Precedence07\n  Precedence07 = Precedence07 Operator07 Precedence06 | \"\" \"\" Precedence06\n  Precedence06 = Precedence06 Operator06 Precedence05 | \"\" \"\" Precedence05\n  Precedence05 = Precedence05 Operator05 Precedence04 | \"\" \"\" Precedence04\n  Precedence04 = \"\"           Operator04 Precedence03 | \"\" \"\" Precedence03 /* Unary */\n  Precedence03 = \"\"           Operator03 Precedence02 | \"\" \"\" Precedence02 /* Special */\n  Precedence02 = Precedence02 Operator02 Precedence03 | \"\" \"\" Precedence01\n  Precedence01 = Arr\n  \n  Parenthesis = \"(\" ArithmeticLogicExp \")\"\n  Arr\n    = Arr \".\" Name CallArgs     -- method\n    | Arr \".\" Name              -- attribute\n    | Arr \"[\" Slice \"]\"         -- slice\n    | Parenthesis\n    | Name (\".\" Name)* CallArgs -- call\n    | number\n    | Variable\n\n  Name  (an identifier)\n    = (letter|\"_\") (letter|\"_\"|digit)*\n\n  number  (a number)\n    = (\"+\"|\"-\")? digit* \".\" digit+ \"E\" (\"+\"|\"-\")? \"digit+\"\n    | (\"+\"|\"-\")? digit* \".\" digit+ \"e\" (\"+\"|\"-\")? \"digit+\"\n    | (\"+\"|\"-\")? digit* \".\" digit+  \"\"  \"\"        \"\"\n    | (\"+\"|\"-\")? digit+ \"\"  \"\"      \"\"  \"\"        \"\"\n  \n  int (an integer) = \"\"  digit+ | \"-\" digit+ | \"+\" digit+\n\n  CallArgs // Using empty strings instead of separate rules\n   = \"(\" Args \",\"  KwArgs \",\"? \")\"\n   | \"(\" Args \",\"? \"\"      \"\"  \")\"\n   | \"(\" \"\"   \",\"? KwArgs \",\"? \")\"\n   | \"(\" \"\"    \"\"  \"\"      \"\"  \")\"\n   \n  Args = NonemptyListOf<ArgValue, \",\">\n  KwArgs = NonemptyListOf<KwArg, \",\">\n  KwArg = Name \"=\" ArgValue\n\n  ArgValue = Constant | JsArray | ArithmeticLogicExp | String\n  Constant = \"True\" | \"False\" | \"None\" | \"np.nan\" | \"np.inf\"\n  JsArray\n    = \"[\" ListOf<ArgValue, \",\"> \",\"? \"]\"\n    | \"(\" ListOf<ArgValue, \",\"> \",\"? \")\"\n\n  String = \"\\'\" any* \"\\'\" | \"\\\"\" any* \"\\\"\"\n   \n  Slice = NonemptyListOf<SliceTerm, \",\">\n  SliceTerm\n    = SliceRange\n    | (\":\" | \"...\" | \"None\") -- constant\n    | (\"True\" | \"False\") -- boolean_constant\n    | JsArray\n    | ArithmeticLogicExp\n  \n  SliceRange\n    = int \":\" int \":\" int\n    | int \":\" int \"\"  \"\"\n    | int \":\" \"\"  \":\" int\n    | int \":\" \"\"  \"\"  \"\"\n    | \"\"  \":\" int \":\" int\n    | \"\"  \":\" int \"\"  \"\"\n    | \"\"  \":\" \"\"  \":\" int\n    | \"\"  \":\" \"\"  \"\"  \"\"\n}\n"])));
exports.ohmGrammar = ohm.grammar(exports.grammar);
var __makeSemantics = function () {
    var semanticVariables = [];
    var semantics = {
        Instruction_sliceAssignment: function ($tgt, _open, $where, _close, $symbol, $src) {
            var _tgt = $tgt.parse();
            var _src = $src.parse();
            var symbol = $symbol.sourceString;
            var where = $where.parse();
            var tgt = _globals_1.nd_modules.basic.asarray(_tgt);
            _globals_1.nd_modules.operators.op_assign[symbol](_tgt, where, _src);
            if (tgt !== _tgt) {
                // WARNING: Creates a copy. This is terrible for arr[2, 4, 3] = 5
                tgt = _globals_1.nd_modules.jsInterface.tolist(tgt);
                while (_tgt.length)
                    _tgt.pop();
                // @ts-ignore
                _tgt.push.apply(_tgt, __spreadArray([], __read(_tgt), false));
            }
            return null;
        },
        Instruction_expression: function ($arr) {
            var arr = $arr.parse();
            if (typeof arr === "number")
                return arr;
            if (typeof arr === "boolean")
                return arr;
            if (Array.isArray(arr))
                return arr;
            if (_globals_1.nd_modules.basic.isarray(arr))
                arr = _globals_1.nd_modules.basic.number_collapse(arr);
            return arr;
        },
        Precedence11: BinaryOperation,
        Precedence10: BinaryOperation,
        Precedence09: BinaryOperation,
        Precedence08: BinaryOperation,
        Precedence07: BinaryOperation,
        Precedence06: BinaryOperation,
        Precedence05: BinaryOperation,
        Precedence04: UnaryOperation,
        Precedence03: UnaryOperation,
        Precedence02: BinaryOperation,
        number: function (arg1, arg2, arg3, arg4, arg5, arg6, arg7) {
            return parseFloat(this.sourceString);
        },
        Arr_slice: function ($arr, _open, $where, _close) {
            var arr = $arr.parse();
            var where = $where.parse();
            return arr.index.apply(arr, __spreadArray([], __read(where), false));
        },
        SliceTerm_constant: function ($x) {
            return $x.sourceString;
        },
        SliceTerm_boolean_constant: function ($x) {
            return $x.sourceString === "True";
        },
        Arr_call: function ($name, $names, _, $callArgs) {
            var name = $name.sourceString + $names.sourceString;
            if (name.slice(0, 3) == "np.")
                name = name.slice(3);
            var func = name.split('.').reduce(function (obj, name) { return obj[name]; }, _globals_1.np);
            if (func === undefined)
                throw new Error("Unrecognized function ".concat(name));
            var _a = $callArgs.parse(), args = _a.args, kwArgs = _a.kwArgs;
            return Object.keys(kwArgs).length == 0 ? func.apply(void 0, __spreadArray([], __read(args), false)) : func.apply(void 0, __spreadArray(__spreadArray([], __read(args), false), [kwArgs], false));
            // return func.bind(kwArgs)(...args); // Old version
        },
        Arr_method: function ($arr, _dot, $name, $callArgs) {
            var arr = $arr.parse();
            var name = $name.sourceString;
            var _a = $callArgs.parse(), args = _a.args, kwArgs = _a.kwArgs;
            if (arr[name] === undefined)
                throw new Error("Unrecognized method ".concat(name));
            // return arr.withKwArgs(kwArgs)[name](...args); // Old version
            return Object.keys(kwArgs).length == 0 ? arr[name].apply(arr, __spreadArray([], __read(args), false)) : arr[name].apply(arr, __spreadArray(__spreadArray([], __read(args), false), [kwArgs], false));
        },
        Parenthesis: function (_, $arr, __) { return $arr.parse(); },
        Arr_attribute: function ($arr, _, $name) { return $arr.parse()[$name.sourceString]; },
        Variable: function (_, $i, __) {
            var i = parseInt($i.sourceString);
            var value = semanticVariables[i];
            var isListOfArrays = Array.isArray(value) && value.length && _globals_1.nd_modules.basic.isarray(value[0]);
            if (Array.isArray(value) && !isListOfArrays)
                value = _globals_1.nd_modules.basic.array(value);
            return value;
        },
        int: function ($sign, $value) {
            var value = parseInt($value.sourceString);
            if ($sign.sourceString == '-')
                return -value;
            else
                return value;
        },
        SliceRange: function ($start, _, $stop, __, $step) {
            return this.sourceString;
        },
        Constant: function ($x) {
            switch ($x.sourceString) {
                case "True": return true;
                case "False": return false;
                case "None": return null;
                case "np.nan": return Number.NaN;
                case "np.inf": return Number.POSITIVE_INFINITY;
            }
            throw new Error("Unrecognized constant ".concat($x.sourceString));
        },
        String: function (_open, $str, _close) {
            return $str.sourceString;
        },
        CallArgs: function (_open, $args, _comma, $kwArgs, _trailing, _close) {
            var args = $args.parse() || [];
            var entries = $kwArgs.parse() || [];
            var kwArgs = Object.fromEntries(entries.map(function (_a) {
                var _b = __read(_a, 2), k = _b[0], v = _b[1];
                // The following is needed because minus integer gets parsed as array.
                if (_globals_1.nd_modules.basic.isarray(v))
                    v = _globals_1.nd_modules.basic.number_collapse(v);
                return [k, v];
            }));
            return { args: args, kwArgs: kwArgs };
        },
        KwArg: function ($key, _equals, $value) {
            var key = $key.sourceString;
            var value = $value.parse();
            return [key, value];
        },
        NonemptyListOf: function (first, _, more) {
            return __spreadArray([first], __read(more.children), false).map(function (c) { return c.parse(); });
        },
        JsArray: function (_open, $list, _trailing, _close) {
            var list = $list.parse();
            // Downcast arrays (needed because, e.g., for [-1, 3, -2], -1 and -2 are interpreted as MyArray rather than int)
            var tolist = _globals_1.nd_modules.jsInterface.tolist;
            for (var i in list)
                if (_globals_1.nd_modules.basic.isarray(list[i]))
                    list[i] = tolist(list[i]);
            return list;
        },
        _terminal: function () { return null; },
    };
    function BinaryOperation($A, $symbol, $B) {
        var A = $A.parse();
        var B = $B.parse();
        var symbol = $symbol.sourceString;
        if (symbol == "" && A === null)
            return B;
        var op = _globals_1.nd_modules.operators.op_binary;
        return op[symbol](A, B);
    }
    function UnaryOperation(_, $symbol, $B) {
        var B = $B.parse();
        var symbol = $symbol.sourceString;
        if (symbol == "")
            return B;
        var ops = _globals_1.nd_modules.elementwise.ops;
        switch (symbol) {
            case "+": return ops["+"](B);
            case "-": return ops["-"](B);
            case "~": return ops["~"](B);
            case "!": return ops["not"](B);
        }
        throw new Error("Programming Error: ".concat(symbol));
    }
    var ohmSemantics = exports.ohmGrammar.createSemantics();
    ohmSemantics.addOperation('parse', semantics);
    /**
     * @param {TemplateStringsArray} template
     * @param {any[]} variables
     */
    function parse(template) {
        var variables = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            variables[_i - 1] = arguments[_i];
        }
        // Replace variables in template with #0# #1# #2#, ...
        var idx = 0;
        var template_with_placeholders = template.join('###').replace(/###/g, function () { return "#".concat(idx++, "#"); });
        semanticVariables.length = 0;
        semanticVariables.push.apply(semanticVariables, __spreadArray([], __read(variables), false));
        var match = exports.ohmGrammar.match(template_with_placeholders);
        if (!match.succeeded())
            throw new Error(match.message);
        return ohmSemantics(match).parse();
    }
    return { parse: parse, ohmSemantics: ohmSemantics, semantics: semantics, semanticVariables: semanticVariables, busy: 0 };
};
exports.__makeSemantics = __makeSemantics;
exports.__parser_pool = [(0, exports.__makeSemantics)()];
/**
 * @param {TemplateStringsArray} template
 * @param {any[]} variables
 */
var parse = function (template) {
    var variables = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        variables[_i - 1] = arguments[_i];
    }
    // Thread control, because the parser depends on semanticVariables,
    // but we don't want to waste CPU time recreating the parser on each call
    // No cleaning is done (we assume that the number of threads is negligible compared to the memory size)
    var pool = exports.__parser_pool;
    for (var i = 0; i < pool.length; i++) {
        var parser = pool[i];
        if (parser.busy++ == 0) {
            try {
                return parser.parse.apply(parser, __spreadArray([template], __read(variables), false));
            }
            finally {
                parser.busy = 0;
            }
        }
        if (i == pool.length)
            pool.push((0, exports.__makeSemantics)());
    }
};
exports.parse = parse;
var templateObject_1;
